'use strict';

exports.initialize = initialize;

function initialize() {
	$(document).off('click.HeaderBanner.Close').on('click.HeaderBanner.Close', '.header-banner .close', function(event) {
		event.preventDefault();
		var $this = $(this);
		
		var contentAssetId = $this.closest('[content-asset-id]').attr('content-asset-id');
		if (contentAssetId) {
			acknowledge(contentAssetId, 'Yes', function() {
				$('.header-banner').hide();
				$(document).trigger('app.resize');
			});
		}
	});

	$(document).off('click.NotificationYes').on('click.NotificationYes', '.notification .yes', function(event) {
		event.preventDefault();
		var $this = $(this);
		var contentAssetId = $this.closest('[content-asset-id]').attr('content-asset-id');
		acknowledge(contentAssetId, 'Yes');
		$this.closest('.notification').addClass('hidden');
	});
	
	$(document).off('click.NotificationNo').on('click.NotificationNo', '.notification .no', function(event) {
		event.preventDefault();
		var $this = $(this);
		var contentAssetId = $this.closest('[content-asset-id]').attr('content-asset-id');
		acknowledge(contentAssetId, 'No');
		window.location.href = $this.attr('href');
	});
}

function acknowledge(notification, acknowledgement, callbackSuccessParameter, callbackErrorParameter) {
	var callbackSuccess = callbackSuccessParameter || function() { };
	var callbackError = callbackErrorParameter || function() { };

	if (notification && acknowledgement) {
		$.ajax({
			url: Urls.Notification.Acknowledge,
			type: 'POST',
			data: {
				Notification: notification,
				Acknowledgement: acknowledgement
			},
			dataType: 'json',
			success: callbackSuccess,
			error: callbackError
		});
	}
}